/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { ContentfulProvider } from './ContentfulContext';

export const withContentfulWrapper = (WrappedComponent, opts = {}) => {
  class ContentfulWrapper extends Component {

    state = {}

    render() {
      const { componentId, componentClass, ...otherProps } = this.props;
      
      return (
        <ContentfulProvider 
          componentId={componentId || opts.componentId}
          componentClass={componentClass || opts.componentClass}
        >
          <WrappedComponent {...otherProps} />
        </ContentfulProvider>
      );
    }
  }

  ContentfulWrapper.displayName = WrappedComponent.displayName || 'ContentfulWrapper';

  if (WrappedComponent?.dataModel) {
    ContentfulWrapper.dataModel = WrappedComponent.dataModel;
  }

  return ContentfulWrapper;
};
